/* LA DIVINE — Garde-fou checkout. Bloque le bouton PAYER et les boutons express (Shop Pay,
   PayPal, Apple Pay) tant qu'une DATE et un CRÉNEAU Pickeasy ne sont pas acquis.

   ── RÉÉCRITURE DU 27/08/2026 — deux défauts corrigés ────────────────────────────────────────
   1) DÉTECTION FAUSSE. L'ancien sélecteur `[id*="pickeasy" i],[class*="pickeasy" i],…` attrapait
      le PREMIER élément portant « pickeasy » dans le DOM. Or l'app injecte très tôt une balise
      `<style id="pickeasy-hide-dynamic-checkout">` (elle masque les boutons express). Une balise
      <style> ne contient aucun <input> → l'ancien code concluait « widget absent » → fail-open.
      Vérifié en direct le 27/08 : le garde-fou ne bloquait JAMAIS rien, sur aucune page.
   2) FAIL-OPEN. En cas de doute, l'ancien code laissait passer. Une commande sans attributs
      Pickeasy est ensuite REJETÉE par le filtre d'entrée de S1 (« Commande Pickeasy (date
      presente) ») : ni événement agenda, ni course Stuart, ni alerte. Panne parfaitement
      silencieuse — exactement ce que le Lot 4 doit supprimer.

   ── PRINCIPE RETENU ─────────────────────────────────────────────────────────────────────────
   · On ne renifle plus le DOM par sous-chaîne. On lit deux sources d'état, dans cet ordre :
       (a) LES ATTRIBUTS DU PANIER — `Translated Order Due Date` / `Translated Order Due Time`.
           C'est la source de vérité : ce sont EXACTEMENT les deux attributs sur lesquels S1
           filtre. Si le panier ne les porte pas, l'automatisation ne verra jamais la commande.
       (b) L'ÉTAT VIVANT DU WIDGET — `window.pickeasyData` (date / time / translatedDate /
           translatedTimeSlot). Sert d'accélérateur pendant la fenêtre de synchronisation du
           panier (Pickeasy affiche lui-même un « Updating your slot and cart details »).
     Déverrouillage si (a) OU (b) est satisfait. Verrouillage sinon.
   · FAIL-CLOSED. Toute incertitude — Pickeasy non chargé, aucun widget enregistré, lecture du
     panier en échec — bloque. Le doute ne profite plus à la commande.
   · Le champ de saisie réel n'est cherché que pour le DIAGNOSTIC (window.__ldGuard), jamais
     comme condition de déblocage : un widget peut légitimement n'exposer aucun <input> natif.

   ⚠️ Conséquence assumée : si Pickeasy ne rend plus rien, PLUS AUCUNE commande ne peut être
   passée. C'est voulu — une commande avalée en silence coûte plus cher qu'une vente bloquée. */
(function () {
  'use strict';
  if (window.__ldGuardLoaded) return;
  window.__ldGuardLoaded = true;

  var MSG = 'Merci de choisir une date et un créneau de livraison avant de valider votre commande.';
  var ATTR_DATE = 'Translated Order Due Date';
  var ATTR_TIME = 'Translated Order Due Time';

  var etat = { attrsOk: false, attrsLus: false, widgets: null };
  var enCours = false;

  function racine() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /** (a) Source de vérité : les attributs que S1 exige réellement. */
  function relireAttributs() {
    if (enCours) return;
    enCours = true;
    fetch(racine() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        var a = (c && c.attributes) || {};
        var d = (a[ATTR_DATE] || '').toString().trim();
        var h = (a[ATTR_TIME] || '').toString().trim();
        etat.attrsOk = !!(d && h);
        etat.attrsLus = !!c;          // lecture en échec => reste false => fail-closed
        etat.panierVide = !!(c && c.item_count === 0);
      })
      .catch(function () { etat.attrsOk = false; etat.attrsLus = false; })
      .then(function () { enCours = false; appliquer(); });
  }

  /** (b) État vivant du widget — accélérateur pendant la synchro du panier. */
  function etatWidget() {
    var d = window.pickeasyData;
    if (!d || typeof d !== 'object') return { charge: false, widgets: 0, choisi: false };
    var w = (d.widgets && typeof d.widgets === 'object') ? Object.keys(d.widgets).length : 0;
    var aDate = !!((d.date || d.translatedDate || '').toString().trim());
    var aSlot = !!((d.time || d.translatedTimeSlot || '').toString().trim());
    return { charge: true, widgets: w, choisi: aDate && aSlot };
  }

  /** Le vrai widget, pour diagnostic uniquement (jamais une condition de déblocage). */
  function champReel() {
    var hote = document.querySelector('pickeasy-app-widget');
    if (!hote) return null;
    var champs = hote.querySelectorAll('input:not([type=hidden]),select,textarea,button');
    return { present: true, taille: hote.innerHTML.length, champs: champs.length };
  }

  function cibles() {
    return {
      payer: Array.prototype.slice.call(document.querySelectorAll(
        '[name="checkout"],button[name="checkout"],.cart__checkout-button,a[href*="/checkout"]')),
      express: Array.prototype.slice.call(document.querySelectorAll(
        '.shopify-payment-button,.dynamic-checkout,[data-shopify="dynamic-checkout"],' +
        'shopify-accelerated-checkout,shopify-accelerated-checkout-cart,shopify-payment-button,' +
        'shop-pay-wallet-button,shopify-paypal-button'))
    };
  }

  function montrerMsg(ancre) {
    var box = document.getElementById('ld-checkout-guard-msg');
    if (!box) {
      box = document.createElement('div');
      box.id = 'ld-checkout-guard-msg';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'color:#8a3b3b;font-family:inherit;font-size:13px;line-height:1.45;margin:10px 0;text-align:center';
      box.textContent = MSG;
      var pt = ancre && ancre.parentNode ? ancre.parentNode : null;
      if (pt) pt.insertBefore(box, ancre); else document.body.appendChild(box);
    }
    box.style.display = 'block';
  }
  function cacherMsg() {
    var b = document.getElementById('ld-checkout-guard-msg');
    if (b) b.style.display = 'none';
  }

  function verrouiller(anomalie) {
    var t = cibles();
    t.payer.concat(t.express).forEach(function (el) {
      el.dataset.ldGuarded = '1';
      el.setAttribute('aria-disabled', 'true');
      el.style.pointerEvents = 'none';
      el.style.opacity = '.5';
    });
    // Anomalie (Pickeasy absent / aucun widget) : le message part tout de suite, sans attendre
    // un clic — c'est le seul signal visible que quelque chose ne va pas.
    if (anomalie && t.payer.length) montrerMsg(t.payer[0]);
  }

  function deverrouiller() {
    var l = document.querySelectorAll('[data-ld-guarded]');
    Array.prototype.forEach.call(l, function (el) {
      el.removeAttribute('aria-disabled');
      el.style.pointerEvents = '';
      el.style.opacity = '';
      delete el.dataset.ldGuarded;
    });
    cacherMsg();
  }

  function appliquer() {
    var w = etatWidget();
    var pret = etat.attrsOk || w.choisi;
    // Anomalie = on ne peut même pas proposer de choix au client.
    var anomalie = !w.charge || w.widgets === 0;

    window.__ldGuard = {
      attrsOk: etat.attrsOk, attrsLus: etat.attrsLus, panierVide: !!etat.panierVide,
      widgetCharge: w.charge, widgetsEnregistres: w.widgets, widgetChoisi: w.choisi,
      champ: champReel(), verdict: pret ? 'DEVERROUILLE' : (anomalie ? 'BLOQUE (anomalie)' : 'BLOQUE (choix manquant)')
    };

    if (etat.panierVide) { deverrouiller(); return; }   // panier vide : rien à garder
    if (pret) deverrouiller(); else verrouiller(anomalie);
  }

  // Clic sur une cible bloquée -> message, et on empêche la navigation.
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-ld-guarded]') : null;
    if (el) { e.preventDefault(); e.stopPropagation(); montrerMsg(el); }
  }, true);

  // Soumission d'un formulaire de commande alors qu'on est bloqué -> on coupe aussi.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;
    if (f.querySelector('[data-ld-guarded]')) { e.preventDefault(); e.stopPropagation(); montrerMsg(f); }
  }, true);

  function boucle() { relireAttributs(); }

  document.addEventListener('change', boucle, true);
  document.addEventListener('input', boucle, true);
  document.addEventListener('cart:update', boucle);
  document.addEventListener('cart:refresh', boucle);

  var mo = new MutationObserver(function () { appliquer(); });

  function init() {
    appliquer();                 // verrouille AVANT toute lecture : fail-closed dès la 1re frame
    relireAttributs();
    mo.observe(document.body, { childList: true, subtree: true });
    // Pickeasy s'injecte de façon asynchrone : quelques repasses.
    [400, 1200, 2500, 5000].forEach(function (d) { setTimeout(function () { relireAttributs(); }, d); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
